import * as $ from 'jquery';
import AnimationEasing from '../../lib/AnimationEasing';
import { Analytics } from '@plaudit/analytics';

export default class MapArea {
	private analytics = Analytics.getInstance();

	constructor() {
		const $map = $('#locationSearchMap');
		if ($map.length === 0) {
			return;
		}
		const $mapResults = $('#mapResults');
		const preventDefaults = document.body.classList.contains('__agentServices');
		const $select = $('#locationSearchForm').find('select');
		const $paths = $map.find('path.map-region');

		var urlParams = new URLSearchParams(window.location.search);
		const hasState = urlParams.has('state');

		const animationStop = function () {
			var fromtop = $mapResults.offset().top - 40;
			$('html, body').stop().animate({
				'scrollTop': fromtop
			}, 1000, <any>AnimationEasing.func.easeOutQuint);
		};
		const updateUrlParameter = (param:String, value:String) => {
			const regExp = new RegExp(param + "(.+?)(&|$)", "g");
			const newUrl = window.location.href.replace(regExp, param + "=" + value + "$2");
			window.history.pushState({}, "", newUrl);
		}
		const updateRegion = (event: Event) => {
			console.log('test');
			$paths.removeClass('isActive');

			const stateSelector = (<HTMLSelectElement>event.target).value;
			$('#us_' + stateSelector.toLowerCase()).addClass('isActive');
			animationStop();
			updateUrlParameter('state', stateSelector);
			this.analytics.trackEvent('Map', 'State Selection', stateSelector);
		};
		const updateSelect = (event: Event) => {
			if (preventDefaults) {
				event.preventDefault();
			}
			var thisId = (<HTMLElement>event.target).getAttribute('id');
			var region = thisId.replace(/us_/, '').toUpperCase();
			$select.val(region).trigger('change');
			animationStop();
			updateUrlParameter('state', region);
		}

		if (hasState) {
			animationStop();
		}

		$map.on('click', 'a', updateSelect);
		$select[0].addEventListener('change', updateRegion);
	}
}
